import {css} from "@emotion/react";
import React from 'react';
import {AQIBar, AQIBarWrapper, AQIThumb, AQIWrapper, HLine, Measure, Name, VLine} from "./styles";


export interface AQICodeProps {
    value: number;
}

const measures = [
    "Good",
    "Moderate",
    "USG",
    "Unhealthy",
    "Very Unhealthy",
    "Hazardous",
];
export const AQICode: React.VFC<AQICodeProps> = ({
    value,
}) => {
    return (
        <AQIWrapper>
            <AQIBarWrapper>
                {measures.map((_, i) => <AQIBar key={i}/>)}
                {measures.map((name, i) => (
                    <Measure key={i}>
                        <VLine />
                        <HLine />
                        <Name>{name}</Name>
                        <HLine />
                        <VLine />
                    </Measure>
                ))}
            </AQIBarWrapper>
            <AQIThumb css={css({
                left: Math.max(0, Math.min(100, value / 604 * 100)) + "%",
            })}/>
        </AQIWrapper>
    );
};